import React from 'react';
import TitlesOverviewContainer from '../views/TitlesOverviewContainer';
import CardContainer from './CardContainer';
import * as SimilarTitlesSelector from '../../data/SimilarTitleSelectors';
import { getJsonData } from 'data/DataStore';


const SimilarTitlesContainer = (props) => {
    const titlesCardModel = SimilarTitlesSelector.getSimilarTitles(getJsonData());
    return (<CardContainer cardName="Similar Titles" cardModel={titlesCardModel} component={TitlesOverviewContainer} itemsToRender={9} {...props}/>);
}

export default SimilarTitlesContainer;



// WEBPACK FOOTER //
// ./src/react/containers/SimilarTitlesContainer.jsx